import React, { useState, useEffect } from 'react'

import {
    Box,
    styled,
    Card,
    Button,
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';

import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import DataGridTable from '../../common/DataGridTable';
import DataGridToolbar from '../../common/DataGridToolbar';
import CommonRestricted from '../../common/CommonRestricted';
import { useAppContextFeatures } from '../../../context/AppContext'

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useItems, itemTypes, targetTypes as itemTargetTypes } from '../../../hooks/api/useItems';
import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { CommonIcons, icons } from "../../common/CommonIcons"
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(3)
}));

export default function ListProducts({
    routeType
}) {

    const navigate = useNavigate();
    const { setSystemLoading } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useItems({ itemType: itemTypes.product, targetType: itemTargetTypes.product });
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = React.createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const result = await list(props)

            return {
                data: result?.data?.products,
                count: result?.data?.nofilter_total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    const handleDelete = async () => {

        setSystemLoading(true)

        try {
            const result = await remove({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

            resetDataGridTableSelection();

        } catch (error) {
            promptMessage(false, error?.message)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([

            {
                name: "item_name",
                header: "Name",
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`product/item/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: "product_code",
                header: "Code",
            },
            {
                name: "model",
                header: "Model",
            },
            {
                name: "brand_name",
                header: "Brand",
            },
            {
                name: "category_name",
                header: "Category",
            },
            {
                name: "items",
                header: "Uom",
                sortable: false,
                renderValue: ({ value, cellProps }) => {

                    let displayValue = value.length ? `${value.length}` : `Empty`

                    const props = {
                        size: 'small',
                        variant: 'outlined',
                    }

                    if (value.length) {

                        return (
                            <Button
                                {...props}
                            >
                                {value.length} Uom
                            </Button>
                        )
                    }

                    return <></>

                }
            },
            {
                name: "status",
                header: "Status",
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            }
        ])
    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("product/item/new"));

                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    // const RenderList = () => (

    //         <StyledCard>
    //             <DataGridToolbar
    //                 gridRef={gridRef}
    //                 selectedRowCount={
    //                     selectedIds.length
    //                 }
    //                 mainMenus={[
    //                     {
    //                         // displayText: "New Product",
    //                         displayIconName: icons.plus,
    //                         onClick: () => {

    //                             navigate(getRoute("product/item/new"));

    //                         }
    //                     },
    //                 ]}
    //                 actionMenus={[
    //                 ]}
    //                 actionOnClickRemove={handleDelete}
    //             />
    //             <DataGridTable
    //                 ref={gridRef}
    //                 refresh={refreshDataGrid}
    //                 fetchData={fetchData}
    //                 dataGrid={{
    //                     idProperty: "id",
    //                     style: {
    //                         // minHeight: 600
    //                     },
    //                     checkboxColumn: true,
    //                     columns,
    //                     defaultFilterValue: filterValues,
    //                     onSelectionChange: (items) => {
    //                         setSelectedIds(
    //                             items
    //                         )
    //                     }
    //                 }}

    //             />
    //         </StyledCard>
    // )

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        // minHeight: 600
                    },
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.items })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Items"
                breadcrumbs={[
                    {
                        displayText: "Items",
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {/* { RenderList() } */}

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
